// @flow
import React, { Component } from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Drawer from "@material-ui/core/Drawer";
import MenuIcon from "@material-ui/icons/Menu";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../types/GeneralTypes";

const styles = (theme: DictionaryType): DictionaryType => ({
  icon: {
    marginLeft: -12
  },
  header: {
    width: "calc(100% - 72px)",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center"
  },
  logo: {
    width: "38px",
    height: "38px"
  },
  title: {
    lineHeight: "38px",
    color: theme.palette.primary.contrastText,
    marginLeft: "8px"
  }
});

type AppbarMenuClassesType = {
  icon: DictionaryType,
  header: DictionaryType,
  logo: DictionaryType,
  title: DictionaryType
};

type AppbarMenuPropsType = {
  classes: AppbarMenuClassesType,
  menus: React$Node,
  logo: React$Node,
  title: string,
  open: boolean,
  toggleDrawer: Function
};

class AppbarMenu extends Component<AppbarMenuPropsType, *> {
  render(): * {
    const classes = this.props.classes;

    return (
      <AppBar position="fixed" color="primary">
        <Toolbar>
          <IconButton
            className={classes.icon}
            color="inherit"
            aria-label="Menu"
            aria-owns={this.props.open ? "mobile-menu-appbar" : null}
            aria-haspopup="true"
            onClick={(): * => this.props.toggleDrawer(true)}
          >
            <MenuIcon />
          </IconButton>
          <div className={classes.header}>
            <img
              alt={this.props.title}
              src={this.props.logo}
              className={classes.logo}
            />
            <Typography variant="h6" className={classes.title}>
              {this.props.title}
            </Typography>
          </div>
          <Drawer
            id="mobile-menu-appbar"
            open={this.props.open}
            onClose={(): * => this.props.toggleDrawer(false)}
          >
            {this.props.menus}
          </Drawer>
        </Toolbar>
      </AppBar>
    );
  }
}

export default withStyles(styles)(AppbarMenu);
